import { render, staticRenderFns } from "./StatisticsRenewalOrder.vue?vue&type=template&id=10a840a5&scoped=true&"
import script from "./StatisticsRenewalOrder.vue?vue&type=script&lang=js&"
export * from "./StatisticsRenewalOrder.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsRenewalOrder.vue?vue&type=style&index=0&id=10a840a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a840a5",
  null
  
)

export default component.exports